export default "__VITE_ASSET__9c76c6e0__"